import contentApi from '../../api/content.api';

// initial state
const state = {
  content: {},
  contents: [],
};

// getters
const getters = {
  content: state => state.content,
  contents: state => state.contents,

  modalContents: state => state.contents.map(content => ({ value: content._id, text: content.name })),
};

// actions
const actions = {
  findAdminContents({ commit }, payload) {
    return contentApi.findAdminContents(payload)
      .then((response) => {
        commit('CONTENTS', response.contents);
      });
  },

  addAdminContent({ commit }, payload) {
    return contentApi.addAdminContent(payload)
      .then((response) => {
        commit('ADD_CONTENT', response.content);
        commit('CONTENT', response.content);
      });
  },

  getAdminContent({ commit }, payload) {
    return contentApi.getAdminContent(payload)
      .then((response) => {
        commit('CONTENT', response.content);
      });
  },

  saveAdminContent({ commit }, payload) {
    return contentApi.saveAdminContent(payload)
      .then((response) => {
        commit('CONTENT', response.content);
      });
  },
};

// mutations
const mutations = {
  CONTENTS(state, contents) {
    state.contents = contents;
  },
  ADD_CONTENT(state, content) {
    state.contents.push(content);
  },
  CONTENT(state, content) {
    state.content = content;
  }
};

export default {
  state,
  getters,
  actions,
  mutations,
};
